export const MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE = 16;
export const MAX_CONTENT_WIDTH = 1376;
export const MAX_WIDE_SCREEN_CONTENT_WIDTH = 1920;
